/**
 * Video banner — click-to-play for hosted video or YouTube/Vimeo embeds.
 */
class VideoBanner extends HTMLElement {
  connectedCallback() {
    this.playButton = this.querySelector('[data-video-play]');
    this.player = this.querySelector('[data-video-player]');
    this.hostedVideo = this.querySelector('video');

    this.onPlay = this.onPlay.bind(this);
    this.playButton?.addEventListener('click', this.onPlay);
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.onPlay);
  }

  onPlay() {
    if (this.classList.contains('is-playing')) return;

    this.classList.add('is-playing');
    this.querySelectorAll('[data-video-play]').forEach((button) => {
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
    });

    if (this.hostedVideo) {
      this.hostedVideo.controls = true;
      this.hostedVideo.play?.().catch(() => {});
      return;
    }

    const iframe = this.player?.querySelector('iframe');
    if (!iframe) return;

    const src = iframe.dataset.src;
    if (!src) return;

    const url = new URL(src, window.location.origin);
    url.searchParams.set('autoplay', '1');
    iframe.src = url.toString();
  }
}

if (!customElements.get('video-banner')) {
  customElements.define('video-banner', VideoBanner);
}
